import React from "react";
import { useMediaQuery } from "hooks/useMediaQuery";
import MobileWarning from "components/MobileWarning";
import { LogoRefabric } from "icons";

// Viewport-based so the gate fires on a real device AND on a resized desktop browser.
// `useIsMobile` keys off screen.width (physical resolution) and never changes on resize.
// Aligned to the mobile-shell breakpoint (833px) — below it the app is in mobile-nav mode,
// so pages that opt out of responsiveness (isResponsive: false) show the warning here.
export const MOBILE_GATE_QUERY = "(max-width: 833px)";

const MobileWarningPage = ({ children }: any) => {
  const isMobile = useMediaQuery(MOBILE_GATE_QUERY);

  if (isMobile) {
    return (
      <main className="bg-black min-h-screen flex flex-col">
        <div className="flex-center w-full py-[23px] border-b border-border">
          <LogoRefabric />
        </div>
        <MobileWarning />
      </main>
    );
  }

  return children;
};

export default MobileWarningPage;
